import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { ShadowElevation } from 'library/constants/styles-config';

export const Container = styled.div`
  position: relative;
  margin-left: -78px;
  margin-right: -52px;
  margin-top: -43px;
  margin-bottom: -43px;
`;
export const ColorWheelSvg = styled.svg`
  position: relative;
  z-index: 2;
  width: 446px;
  height: 446px;
`;
export const ColorWheelInner = styled.div`
  position: absolute;
  z-index: 3;
  width: 200px;
  height: 200px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  pointer-events: none;
  background-color: ${Colors.shade08};
  border-radius: 50%;
`;

export const ColorWheelResult = styled.div.attrs(({ color }) => ({
  style: {
    backgroundColor: color,
  },
}))`
  position: absolute;
  z-index: 3;
  border-radius: 50%;
  width: 72px;
  height: 72px;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
`;

export const ColorWheelBg = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  cursor: pointer;
  width: 300px;
  height: 300px;
  border-radius: 50%;
  background-image: conic-gradient(red, yellow, lime, aqua, blue, magenta, red)
`;
export const Pointer = styled.div.attrs(({ left, top }) => ({
  style: {
    left,
    top,
  },
}))`
  position: absolute;
  z-index: 4;
  width: 72px;
  height: 72px;
  box-sizing: border-box;
  border: 16px solid ${Colors.shade08};
  border-radius: 50%;
  box-shadow: ${ShadowElevation};
  pointer-events: none;
`;
